import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import MyProjectsContractsActionButtons from '@/views/my-projects/components/contracts/MyProjectsContractsActionButtons.vue';
import MyProjectContractsNewContractAction from '@/views/my-projects/components/contracts/MyProjectContractsNewContractAction.vue';
import { InfoBoxType } from '@/models/InfoBox';
import BCXSidebarOrLayer from '@/components/molecules/BCXSidebarOrLayer.vue';
import useProjectsContractsActionState from '@/views/my-projects/components/contracts/myProjectsContractsActionState';
import useI18n from '@/mixins/useI18n';
import Chevron from '@/components/svg-components/Chevron.vue';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractsActions',
  props: {
  inBox: Boolean
},
  setup(__props) {

const { mode } = useProjectsContractsActionState();
const { t } = useI18n();
const { isMobileWidth, isTabletWidth } = useResponsiveness();

const infoBoxType = computed(() => {
  if (mode.value === 'new-contract') {
    return InfoBoxType.INFOBOX_APPLY;
  }
  if (mode.value === 'contract-actions') {
    return InfoBoxType.INFOBOX_CONTRACT_ACTIONS;
  }
  return InfoBoxType.INFOBOX_STANDARD;
});

const hasBackButton = computed(() => mode.value === 'new-contract');



const onNewContract = () => {
  mode.value = 'new-contract';
};

const title = computed(() => {
  if (mode.value === 'new-contract') {
    return `${t('contracts.actions.create-contract.title')}`;
  }
  if (mode.value === 'contract-actions') {
    return `${t('contracts.actions.sidebar-title-contracts')}`;
  }
  return `${t('contracts.actions.sidebar-title')}`;
});

return { __sfc: true,mode, t, isMobileWidth, isTabletWidth, infoBoxType, hasBackButton, onNewContract, title, MyProjectsContractsActionButtons, MyProjectContractsNewContractAction, BCXSidebarOrLayer, Chevron }
}

})